import { apiClient } from './apiClient';
import { ParsedInvoice } from '../types/invoiceImport';

export const invoiceImportService = {
  // Импорт инвойса из PDF
  importInvoice: async (companyId: string, file: File): Promise<ParsedInvoice> => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await apiClient.post(`/companies/${companyId}/invoices/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  // Массовый импорт инвойсов
  importBulkInvoices: async (companyId: string, files: File[]) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await apiClient.post(`/companies/${companyId}/invoices/import-bulk`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  // Получение статуса обработки
  getProcessingStatus: async (companyId: string, processingId: string) => {
    const response = await apiClient.get(`/companies/${companyId}/invoices/processing-status/${processingId}`);
    return response.data;
  },

  // Создание контрагента из распознанных данных
  createCounterpartyFromParsed: async (companyId: string, parsedInvoice: ParsedInvoice) => {
    const response = await apiClient.post(`/companies/${companyId}/invoices/create-counterparty-from-parsed`, parsedInvoice);
    return response.data;
  },

  // Создание инвойса из распознанных данных
  createInvoiceFromParsed: async (companyId: string, parsedInvoice: ParsedInvoice) => {
    const response = await apiClient.post(`/companies/${companyId}/invoices/create-from-parsed`, parsedInvoice);
    return response.data;
  },

  // Массовое создание инвойсов из обработанных данных
  createAllInvoicesFromProcessed: async (companyId: string, processingId: string) => {
    const response = await apiClient.post(`/companies/${companyId}/invoices/create-all-from-processed?processingId=${processingId}`);
    return response.data;
  },

  // Отмена обработки
  cancelProcessing: async (companyId: string, processingId: string) => {
    const response = await apiClient.post(`/companies/${companyId}/invoices/processing-status/${processingId}/cancel`);
    return response.data;
  },
};
